/**
 * @generated SignedSource<<9d2b616cba18eea344e2c4a197871d87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BridgeStatus = "FAILED" | "PENDING" | "SUCCESSFUL" | "%future added value";
export type ChainIdentifier = "ABSTRACT_TESTNET" | "AMOY" | "APE_CHAIN" | "APE_CURTIS" | "ARBITRUM" | "ARBITRUM_NOVA" | "ARBITRUM_SEPOLIA" | "AVALANCHE" | "AVALANCHE_FUJI" | "B3" | "B3_SEPOLIA" | "BAOBAB" | "BASE" | "BASE_SEPOLIA" | "BERA_CHAIN" | "BLAST" | "BLAST_SEPOLIA" | "BSC" | "BSC_TESTNET" | "ETHEREUM" | "FLOW" | "FLOW_TESTNET" | "GUNZILLA" | "GUNZILLA_TESTNET" | "KLAYTN" | "MATIC" | "MONAD_TESTNET" | "OPTIMISM" | "OPTIMISM_SEPOLIA" | "RONIN" | "SAIGON_TESTNET" | "SEI" | "SEI_TESTNET" | "SEPOLIA" | "SHAPE" | "SOLANA" | "SOLDEV" | "SONEIUM" | "SONEIUM_MINATO" | "UNICHAIN" | "ZORA" | "ZORA_SEPOLIA" | "ZORA_TESTNET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Swap_metadata$data = {
  readonly bridgeMetadata: {
    readonly aggregator: string | null | undefined;
    readonly bridgeStatus: BridgeStatus;
    readonly expectedBridgeCompletionTime: number | null | undefined;
  } | null | undefined;
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly chain: {
        readonly identifier: ChainIdentifier;
      };
      readonly decimals: number | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly quantity: string;
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly chain: {
        readonly identifier: ChainIdentifier;
      };
      readonly decimals: number | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly quantity: string;
  }>;
  readonly " $fragmentType": "Swap_metadata";
};
export type Swap_metadata$key = {
  readonly " $data"?: Swap_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"Swap_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "decimals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChainType",
        "kind": "LinkedField",
        "name": "chain",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identifier",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantity",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Swap_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BridgeMetadataType",
      "kind": "LinkedField",
      "name": "bridgeMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bridgeStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expectedBridgeCompletionTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aggregator",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "6bfe82411a1cccbab9918ff6958fb73e";

export default node;
